module.exports = __webpack_public_path__ + "img/booking_Cancel.d6e653a4.svg";